import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

export function useTranslate() {
    const page = usePage()

    const translations = computed<Record<string, string>>(
        () => (page.props.translations as Record<string, string>) ?? {}
    )

    function t(key: string, replacements: Record<string, string | number> = {}): string {
        let value = translations.value[key] ?? key
        for (const [k, v] of Object.entries(replacements)) {
            value = value.replace(`:${k}`, String(v))
        }
        return value
    }

    return { t, locale: computed(() => page.props.locale as string) }
}
